import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
// import reportWebVitals from './reportWebVitals';
import store from './store';
import { BrowserRouter } from 'react-router-dom'; 
// import AppRoutes from './routes'; // Importar AppRoutes
// import Login from './components/Login/Login';
import App from './App';
import SessionHandler from './components/SessionHandler/SessionHandler'; // Importa el componente

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <React.StrictMode>
    
      <BrowserRouter>
      {/* <SessionHandler>  */}
          {/* <Route path='/login' element={<Login/>}/>  */}
          <App /> 
          {/* </SessionHandler>  */}
      </BrowserRouter>
      
    </React.StrictMode>
  </Provider>
);
